import { render, staticRenderFns } from "./FileInputDinamicField.vue?vue&type=template&id=c865ef6a&"
import script from "./FileInputDinamicField.vue?vue&type=script&lang=js&"
export * from "./FileInputDinamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
